import { useState, useEffect } from "react";
import ServiceCard from "./ServiceCard";

const Services = ({ category }) => {
  const [services, setServices] = useState([]);

  useEffect(() => {
    import(`../data/services/${category}.js`)
      .then((module) => setServices(module.default))
      .catch((error) => console.error("Error loading services:", error));
  }, [category]);

  // Group services into alternating rows: 3, 2, 3, 2...
  const getGroupedServices = () => {
    const result = [];
    let i = 0;
    let toggleThree = true;

    while (i < services.length) {
      const count = toggleThree ? 3 : 2;
      result.push(services.slice(i, i + count));
      i += count;
      toggleThree = !toggleThree;
    }

    return result;
  };

  const groupedServices = getGroupedServices();

  return (
    <section className="services-section py-16 bg-background text-text">
      <div className="max-w-[1140px] mx-auto px-4">
        <div className="text-center mt-10 mb-8">
          <h2 className="text-4xl text-left tracking-[6px] uppercase text-primary font-light mb-4">
            {["home", "about", "services"].includes(category) ? "Our Services" : `Our ${category} Services`}
          </h2>
          <p className="text-xl capitalize font-light text-left text-darkBackground font-gilda">
            {["home", "services"].includes(category)
              ? "Transform your home with our expert remodeling services."
              : `Explore our specialized ${category} remodeling services.`}
          </p>
        </div>

        {/* Render grouped rows dynamically */}
        {groupedServices.map((group, rowIndex) => (
          group.length === 1 ? (
            // Use flex layout for single card, center it
            <div key={rowIndex} className="flex mt-8 lg:mx-8 justify-center">
              <div className="w-full lg:w-1/2">
                <ServiceCard
                  key={`${rowIndex}-0`}
                  imageSrc={group[0].imageSrc}
                  title={group[0].title}
                  description={group[0].description}
                  link={group[0].link}
                  height={group[0].height}
                />
              </div>
            </div>
          ) : (
            // Grid layout for 2 or 3 items
            <div
              key={rowIndex}
              className={`grid gap-8 mt-8 ${
                group.length === 3
                  ? "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
                  : "grid-cols-1 sm:grid-cols-2 lg:grid-cols-2"
              }`}
            >
              {group.map((service, index) => (
                <ServiceCard
                  key={`${rowIndex}-${index}`}
                  imageSrc={service.imageSrc}
                  title={service.title}
                  description={service.description}
                  link={service.link}
                  height={service.height}
                />
              ))}
            </div>
          )
        ))}
        {category !== "services" && (
          <div className="text-center mt-12">
            <a
              href="/services"
              className="inline-block text-xl uppercase py-3 px-8 bg-primary text-white font-base hover:bg-black transition-all duration-500 ease-in-out"
            >
              See All Our Services
            </a>
          </div>
        )}
      </div>
    </section>
  );
};

export default Services;
